import React, { createContext, useContext } from "react";

export const LanguageContext = createContext({
  t: (key: string) => key,
  language: "en",
  setLanguage: () => {},
});

export const useLanguage = () => {
  return {
    t: (key: any) => key,
    language: "en",
    setLanguage: () => {},
  };
};

export const T: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};
